var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("contact-method-icon contact-method-icon--" + _vm.type)})}
var staticRenderFns = []

export { render, staticRenderFns }